import type { FC } from "react";

import type { ChatMessageWithUIState, MessageToolType } from "@virtual-brain-lib/types";

import {
	ToolCardCodeBasedTableAnalysis,
	ToolCardDeepDiff,
	ToolCardDocumentAnalysis,
	ToolCardDocuments,
	ToolCardGroup,
	ToolCardLinks,
	ToolCardMailbox,
	ToolCardParentBlocks,
} from "../../mainframe/tool-card";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TOOLS: Record<MessageToolType, FC<{ state: any }>> = {
	documents: ToolCardDocuments,
	links: ToolCardLinks,
	analysis: ToolCardDocumentAnalysis,
	codeBasedTableAnalysis: ToolCardCodeBasedTableAnalysis,
	"deep-diff": ToolCardDeepDiff,
	mailbox: ToolCardMailbox,
	"parent-blocks": ToolCardParentBlocks,
};

export function ToolCards({
	className,
	message,
}: {
	readonly message: ChatMessageWithUIState;
	readonly className?: string;
}) {
	if (!message.tools?.length) {
		return null;
	}

	return (
		<ToolCardGroup className={className}>
			{message.tools?.map((tool) => {
				const Component = TOOLS[tool.type];

				return <Component key={tool.type} state={tool.data} />;
			})}
		</ToolCardGroup>
	);
}
